import React, { useEffect } from "react";
import { connect } from "react-redux";
import { loadTree } from "./loadTree";
import ImageBrandHilite from "./ImageBrandHilite";
import AllYourSiteMenu from "./AllYourSiteMenu";
import DashboardPublisher from "./DashboardPublisher";
import UserMenu from "./UserMenu";
import PublisherMenu from "./PublisherMenu";
import ManagePublisherMenu from "./ManagePublisherMenu";
import FinanceMenu from "./FinanceMenu";
import ManageFinanceMenu from "./ManageFinanceMenu";
import ReportPositionMenu from "./ReportPositionMenu";
import ReportMenu from "./ReportMenu";
import SupportMenu from "./SupportMenu";

function Sidebar({ permissionsUser, openItem = null, activeItem = null }) {
  useEffect(() => {
    loadTree();
  }, []);

  let tagMenu;
  if (permissionsUser.includes("view-all-user")) {
    tagMenu = <UserMenu openItem={openItem} activeItem={activeItem} />;
  }

  let ticketMenu = <SupportMenu openItem={openItem} activeItem={activeItem} />;

  let dashboardMenu;
  if (permissionsUser.includes("add-site-publisher-via-user")) {
    dashboardMenu = <DashboardPublisher activeItem={activeItem} />;
  }

  let publisherMenu;
  if (permissionsUser.includes("add-site-publisher-via-user")) {
    publisherMenu = <PublisherMenu activeItem={activeItem} />;
  }

  let reportPositionMenu;
  if (permissionsUser.includes("add-site-publisher-via-user")) {
    reportPositionMenu = <ReportPositionMenu activeItem={activeItem} />;
  }

  let mangePublisherMenu;
  if (permissionsUser.includes("view-all-user")) {
    mangePublisherMenu = (
      <ManagePublisherMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let mangeFinanceMenu;
  if (permissionsUser.includes("view-all-user")) {
    mangeFinanceMenu = (
      <ManageFinanceMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let financeMenu;
  if (permissionsUser.includes("add-site-publisher-via-user")) {
    financeMenu = <FinanceMenu openItem={openItem} activeItem={activeItem} />;
  }

  let reportMenu;
  if (permissionsUser.includes("add-site-publisher-via-user")) {
    reportMenu = <ReportMenu activeItem={activeItem} />;
  }

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <ImageBrandHilite />

      <div className="sidebar" id="sidebar" style={{ direction: "rtl" }}>
        <div style={{ direction: "rtl" }}>
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {dashboardMenu}
              {reportMenu}
              {tagMenu}
              <AllYourSiteMenu activeItem={activeItem} />
              {publisherMenu}
              {reportPositionMenu}
              {mangePublisherMenu}
              {financeMenu}
              {mangeFinanceMenu}
              {ticketMenu}
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
}

const mapStateToProps = (state) => {
  return {
    permissionsUser: state.main.permissionsUser,
    role: state.main.role,
  };
};

const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
